<template>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  // components: {VeLine, VCalendar},
	data(){
		return {
		}
	},
	methods: {
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
	
</style>
